export const CALC_ROUTES = {
  Loan: [
    { path: '/emi',           name: 'EMI Calculator',       desc: 'Loan EMI instantly',         icon: '🏦' },
    { path: '/home-loan',     name: 'Home Loan EMI',        desc: 'Home loan installment',      icon: '🏡' },
    { path: '/home-loan-smart', name: 'Smart Loan Prepayment',desc: 'Home Loan-Smart Prepayment', icon: '🤖' },
    { path: '/car-loan',      name: 'Car Loan EMI',         desc: 'Car loan EMI calculator',    icon: '🚗' },
    { path: '/business-loan', name: 'Business Loan',        desc: 'Business EMI planner',       icon: '🏢' },
    { path: '/reducing-rate', name: 'Reducing Rate',        desc: 'Find effective interest',    icon: '📉' },
  ],
  Investment: [
    { path: '/sip',           name: 'SIP Calculator',       desc: 'Monthly SIP returns',        icon: '📈' },
    { path: '/step-up-sip',   name: 'Step-Up SIP',          desc: 'SIP with annual step-up',    icon: '⬆️' },
    { path: '/lumpsum',       name: 'Lumpsum Calculator',   desc: 'One-time investment',        icon: '💎' },
    { path: '/swp',           name: 'SWP Calculator',       desc: 'Systematic withdrawal',      icon: '💸' },
    { path: '/mf-return',     name: 'MF Return',            desc: 'Mutual fund CAGR',           icon: '📊' },
    { path: '/fd',            name: 'FD Calculator',        desc: 'Fixed deposit maturity',     icon: '💰' },
    { path: '/rd',            name: 'RD Calculator',        desc: 'Recurring deposit',          icon: '🔄' },
    { path: '/ppf',           name: 'PPF Calculator',       desc: 'Public provident fund',      icon: '🏛️' },
    { path: '/ssy',           name: 'SSY Calculator',       desc: 'Sukanya Samriddhi Yojana',   icon: '👧' },
    { path: '/epf',           name: 'EPF Calculator',       desc: 'Employee provident fund',    icon: '👷' },
  ],
  Tax: [
    { path: '/income-tax',    name: 'Income Tax',           desc: 'New vs old regime',          icon: '📋' },
    { path: '/gst',           name: 'GST Calculator',       desc: 'Add or remove GST',          icon: '📊' },
    { path: '/hra',           name: 'HRA Calculator',       desc: 'HRA tax exemption',          icon: '🏠' },
    { path: '/tds',           name: 'TDS Calculator',       desc: 'TDS deduction',              icon: '📑' },
    { path: '/capital-gain',  name: 'Capital Gain',         desc: 'STCG & LTCG tax',           icon: '💹' },
  ],
  Business: [
    { path: '/profit-margin', name: 'Profit Margin',        desc: 'Gross & net margin',         icon: '🎯' },
    { path: '/depreciation',  name: 'Depreciation',         desc: 'SLM & WDV method',           icon: '📉' },
    { path: '/brokerage',     name: 'Brokerage',            desc: 'Stock trading charges',      icon: '📊' },
    { path: '/margin',        name: 'Margin Calculator',    desc: 'Trading margin required',    icon: '⚖️' },
    { path: '/salary',        name: 'Salary Calculator',    desc: 'In-hand salary',             icon: '💼' },
    { path: '/stock-average', name: 'Stock Average',        desc: 'Average stock buy price',    icon: '📊' },
  ],
  Policy: [
      { path: '/privacy-policy', name: 'Privacy-policy', icon:'🔏'},
      { path: '/termsConditions', name: 'Terms & Conditions', icon:'📝'},
      { path: '/disclaimer', name: 'Disclaimer', icon:'⚠️'},
  ],
};